import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import * as types from './mutation-types'

Vue.use(Vuex)

const mutations = {
    [types.SET_ANSWER] (state, { number }) {
        state.answers[number]++
    },
    [types.CLEAR_ANSWERS] (state) {
        state.answers = [0,0,0,0]
    },
    [types.SET_USER] (state, { name, email }) {
        state.user = {
            name: name,
            email: email
        }
    },
    [types.SET_CLIENT] (state, { client }) {
        state.client = client
    },
    [types.CLEAR_CLIENT] (state) {
        state.client = {
            name: null,
            logo: null
        }
    },
}

const state = {
    answers: [0,0,0,0],
    user: {
        name: null,
        email: null
    },
}

const getters = {
    getAnswers: state => state.answers,
    getUser: state => state.user
}

const actions = {
    setAnswer({commit}, answer) {
        commit(types.SET_ANSWER, {
            number: answer
        });
    },
    clearAnswers({commit}) {
        commit(types.CLEAR_ANSWERS)
    },
    setUser({commit}, data) {
        commit(types.SET_USER, {
            name: data.name,
            email: data.email
        });
    }
}

export default new Vuex.Store({
    state,
    getters,
    actions,
    mutations,
    plugins: [createPersistedState()]
})
